import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isLoggedIn } from 'state/selectors/user';
import RecentFormsComponent from './recent-forms';

const selector = createSelector(isLoggedIn, (isUserLoggedIn) => ({ isUserLoggedIn }));
export const RecentForms = connect(selector)(RecentFormsComponent);
